export function convertDate (value) {
	if (value) {
		var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
		var date = new Date(value)
		var year = date.getFullYear()
		var month = months[date.getMonth()]
		var day = date.getDate()
		return day + ' ' + month + ' ' + year
	}
}

export function convertDateTime (value) {
	if (value) {
		var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
		var date = new Date(value)
		var year = date.getFullYear()
		var month = months[date.getMonth()]
		var day = date.getDate()
		var hours = date.getHours()
		var minutes = "0" + date.getMinutes()
		return day + ' ' + month + ' ' + year + ', ' + hours + ':' + minutes.substr(-2)
	}
}

export function convertCurrency (value) {
	return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' SEK' : '0 SEK'
}
